<template>
	<div>
		<div v-if="loading" class="dynvibeLoading"></div>
		<div v-else-if="!mutableProfiles || mutableProfiles.length === 0" class="noData"><p>No Data to display</p></div>
		<div v-else class="profiles-circle-container">
			<swiper
				ref="swiper"
				:cssMode="true"
				:slidesPerView="15"
				:spaceBetween="30"
				:slidesPerGroup="3"
				:pagination="{
					clickable: true,
				}"
				:navigation="true"
				class="dynvibeGalleryProfiles mySwiper"
			>
				<swiper-slide class="dynvibeGalleryProfilesImg swiper-slide" v-for="n in profileColumns" :key="n">
					<profilecircle v-if="mutableProfiles[(n - 1) * 2]" :profile="mutableProfiles[(n - 1) * 2]"></profilecircle>
					<profilecircle
						v-if="mutableProfiles[(n - 1) * 2 + 1]"
						:profile="mutableProfiles[(n - 1) * 2 + 1]"
						:second="true"
					></profilecircle>
				</swiper-slide>
			</swiper>
		</div>
	</div>
</template>
<script>
import profilecircle from "@/components/globalVue/ProfileCircle.vue";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
// import "swiper/css";

import "swiper/swiper-bundle.css";

import "swiper/swiper.min.css";

// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Mousewheel, Keyboard } from "swiper";
// install Swiper modules
SwiperCore.use([Navigation, Pagination, Mousewheel, Keyboard]);

export default {
	name: "listprofilecircles",
	props: {
		profiles: {},
		axios: {
			type: String,
			default: () => "",
		},
		gender: {},
	},
	data() {
		return {
			loading: true,
			mutableProfiles: this.profiles,
			swiperOptions: {
				// cssMode: true,
				// pagination: {
				// 	el: ".swiper-pagination-pmc",
				// 	clickable: true,
				// },
				// mousewheel: true,
				// keyboard: true,
				// slidesOffsetBefore: 50,
				// slidesOffsetAfter: 50,
				// autoHeight: true,
				// // slidesPerView: "auto",
				// spaceBetween: 30,
				// loop: false,
				// initialSlide: 0,
			},
			//slide: 0,
			//sliding: null,
		};
	},
	components: {
		profilecircle: profilecircle,
		swiper: Swiper,
		SwiperSlide,
	},
	computed: {
		profileColumns() {
			// Has to be dynamically computed because it is needed in the mounted to make the slider work
			return this.mutableProfiles.length % 2 === 0
				? Math.floor(this.mutableProfiles.length / 2)
				: Math.floor(this.mutableProfiles.length / 2) + 1;
		},
	},
	provide() {
		return {
			carousel: this,
		};
	},
	methods: {
		/*onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},*/
		prepareParameters() {
			let p = {};
			this.$attrs.search !== "" ? (p.search = this.$attrs.search) : false;
			this.$attrs.panel !== "" ? (p.panel = this.$attrs.panel) : false;
			this.$attrs.segment !== "" ? (p.segment = this.$attrs.segment) : false;

			p.impact_score = {
				gt: this.$attrs.impact_score_min,
				lt: this.$attrs.impact_score_max,
			};
			this.$attrs.impact_score_max == "" ? delete p.impact_score.lt : false;
			this.$attrs.impact_score_min == "" ? delete p.impact_score.gt : false;

			if (this.$attrs.checkbox_all == true) {
				p.is_checked = ["checked", "unchecked"];
				p.no_segment = true;
			} else {
				p.is_checked = this.$attrs.is_checked;

				this.$attrs.no_segment == true ? (p.no_segment = true) : false;

				p.is_checked.length < 1 ? delete p.is_checked : false;
			}
			return p;
		},
		loadComponent() {
			this.loading = true;
			if (this.axios) {
				let data = {
					gender: this.gender,
				};
				let p = { ...this.$store.getters.parameters, ...this.prepareParameters() };
				let params = { parameters: p, data: data };

				this.$axios
					.get(this.$backendUrl + this.axios, {
						params: params,
						paramsSerializer: (params) => {
							return this.$Qs.stringify(params, { arrayFormat: "brackets" });
						},
					})
					.then((profiles) => {
						this.loading = false;
						this.mutableProfiles = profiles.data;
					});
			} else {
				this.loading = false;
				this.mutableProfiles = this.profiles;
			}
		},
		prevSlide() {
			this.$refs.swiper.$swiper.update();
			this.$refs.swiper.$swiper.slidePrev();
		},
		nextSlide() {
			this.$refs.swiper.$swiper.update();
			this.$refs.swiper.$swiper.slideNext();
		},
	},
	watch: {
		gender: function () {
			this.loadComponent();
		},
	},
};
</script>

<style scoped>
.dynvibeGalleryProfiles {
	margin-top: 20px;
}

.profiles-circle-container {
	margin-top: 45px;
	margin-bottom: 20px;
}

.swiper {
	width: 100%;
	height: 100%;
	min-height: 300px;
	min-width: 300px;
}
.swiper-slide {
	padding-left: 10px;
	padding-right: 10px;
	width: unset;
}
/*.swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #fff;

	!* Center slide text vertically *!
	display: -webkit-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	-webkit-justify-content: center;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center;
}*/

.swiper-slide img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.swiper-wrapper {
	width: 89%;
	margin: auto;
}
.swiper-pagination {
	position: unset !important;
	margin-top: 20px;
}

.swiper-button-next-pmc {
	right: 35px;
	top: 30%;
	color: #9e9e9e;
	font-size: 20px;
	position: absolute;
}

.swiper-button-prev-pmc {
	left: 35px;
	top: 30%;
	color: #9e9e9e;
	font-size: 20px;
	position: absolute;
}

.swiper-button-next-pmc:hover,
.swiper-button-prev-pmc:hover {
	color: #33d1cd;
}

.swiper-button-next-pmc:focus,
.swiper-button-prev-pmc:focus {
	outline: none !important;
}
.dynvibeGalleryProfilesImg {
	margin-right: 0px !important;
}
</style>
